import { render, staticRenderFns } from "./toReg.vue?vue&type=template&id=14158684&scoped=true"
import script from "./toReg.vue?vue&type=script&lang=js"
export * from "./toReg.vue?vue&type=script&lang=js"
import style0 from "./toReg.vue?vue&type=style&index=0&id=14158684&prod&lang=scss&scoped=true"
import style1 from "./toReg.vue?vue&type=style&index=1&id=14158684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14158684",
  null
  
)

export default component.exports